import axios from "@/axios";
import excel from 'xlsx'

const defaultData = {
    id: null,
    userId: null,
    name: null,
    type: "LINEITEM",
    organizations: null,
    services: null,
    countrys: null,
    theaters: null,
    orderStatuses: null,
    states: null,
    paymentMethods: null,
    years: null,
    from: null,
    to: null,
    columns: null
}

export const namespaced = true

export const state = {
    userId: null,
    orderColumns: [],
    lineItemColumns: [],
    jointStaffOrganizations: [],
    countrySummaryList:[],
    countries: [],
    theaters:[],
    statuses: [],
    states: [],
    paymentMethods:[],
    reports: [],
    report: Object.assign({}, defaultData),
}

export const getters = {
    userId: state => state.userId,
    orderColumns: state => state.orderColumns,
    lineItemColumns: state => state.lineItemColumns,
    jointStaffOrganizations: state => state.jointStaffOrganizations,
    countrySummaryList: state=> state.countrySummaryList,
    countries: state => state.countries,
    theaters:state => state.theaters,
    statuses: state => state.statuses,
    states: state => state.states,
    paymentMethods:state => state.paymentMethods,
    reports: state => state.reports,
    report: state => state.report,
    reportType: state => state.report.type
}

export const mutations = {
    SET_USERID: (state, id) => (state.userId = id),
    SET_COLUMNS:(state, response) => {
        state.orderColumns = response.data.orderColumns
        state.lineItemColumns = response.data.lineItemColumns
    },
    SET_JOINT_STAFF_ORGANIZATIONS: (state, response) => (state.jointStaffOrganizations = [response.data]),
    SET_COUNTRY_SUMMARY_LIST:(state, response) =>(state.countrySummaryList = [response]),
    SET_COUNTRIES: (state, response) => (state.countries = response.data),
    SET_THEATERS: (state, response) => (state.theaters = response.data),
    SET_STATUSES:  (state, response) => (state.statuses = response.data),
    SET_STATES:  (state, response) => (state.states = response.data),
    SET_PAYMENT_METHODS: (state, response) => (state.paymentMethods = response.data),
    SET_REPORTS: (state, response) => (state.reports = response.data),
    SET_REPORT: (state, response) => state.report = Object.assign({}, defaultData, response.data),
    CLEAR_REPORT: (state) => state.report = Object.assign({}, defaultData),
}

export const actions = {
    async getColumns({ commit }) {
        commit('SET_COLUMNS', await axios.get("/api/orderreports/columns"))
    },
    async getCountries({ commit }) {
        commit('SET_COUNTRIES', await axios.get("/api/orderreports/countries"))
    },
    async getJointStaffOrganizations({ commit }) {
        commit('SET_JOINT_STAFF_ORGANIZATIONS', await axios.get("/api/orderreports/organizations"))
    },
    async getCountrySummaryList({commit}){
        let response = await axios.get("/api/countries/cocom/tree/countrires")
       let data = response.data
       // make it negative to be separated from the country id
        data.forEach(e => { 
            e.id = e.id * -1
        });
        commit('SET_COUNTRY_SUMMARY_LIST',data)
    },
    async getTheaters({ commit }) {
        commit('SET_THEATERS', await axios.get("/api/orderreports/theaters"))
    },
    async getStatuses({ commit }) {
        commit('SET_STATUSES', await axios.get("/api/orderreports/statuses"))
    },
    async getStates({ commit }) {
        commit('SET_STATES', await axios.get("/api/orderreports/states"))
    },
    async getPaymentMethods({ commit }) {
        commit('SET_PAYMENT_METHODS', await axios.get("/api/orderreports/paymentmethods"))
    },
    async getReports({ commit }) {
        commit('SET_REPORTS', await axios.get("/api/orderreports/user/"))
    },
    async getReportsByUserId({ commit, state }) {
        commit('SET_REPORTS', await axios.get(`/api/orderreports/user/${state.userId}`))
    },
    async getReport({ commit }, id) {
        commit('SET_REPORT', await axios.get(`/api/orderreports/${id}`))
    },
    async removeReport({ commit }, id) {
        commit('SET_REPORT', await axios.delete(`/api/orderreports/${id}`))
    },
    async clearReport({ commit }) {
        commit('CLEAR_REPORT')
    },
    saveReport({ commit, state }) {
        return new Promise((resolve, reject) => {

            axios.post('/api/orderreports', state.report, { showToast: true, message: "Report saved successfully", })
                .then((response) => {
                    return resolve(response.data);
                })
                .catch(function (error) {
                    return reject("There was an error saving the Report to the server..." + error.response.data);
                })
        });
    }
}
